export default {
  postureReport: "Отчет о позе",
  postureData: "Данные о позе",
  postureDataContrast: "Контраст данных о позе",
  postureRiskContrast: "Контраст риска позы",
  postureDataTrend: "Тенденция данных о позе",
  postureRiskTrend: "Тенденция риска позы",
  postureLogData: "Данные журнала позы",
  lateralhead: "Боковое наклон головы",
  unevenshoulder: "Неровные плечи",
  scoliosis: "Сколиоз",
  unevenhip: "Боковой наклон таза",
  xleg: "Нога в форме X",
  oleg: "Нога в форме O",
  roundedshoulder: "Круглая плечо",
  kneehyperextension: "Гиперэкстензия колена",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "Голова вперед",
  toTheLeft: "(левая)",
  toTheRight: "(правая)",
  bracketsLeft: "(Л)",
  bracketsRight: "(П)",
  bracketsNormal: "(Нормальный)",
  leg: "Ноги",
  legLeft: "Ноги (Л)",
  legRight: "Ноги (П)",
  riskAssessment: "Оценка риска",
  muscleState: "Состояние мышц",
  muscleStateDesc: "Не обнаружено никаких аномальных мышечных состояний",
  testTime: "Время теста",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Пункт",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Муаровое изображение",
  lAbnormalRisk: "Л Риск",
  mAbnormalRisk: "М Риск",
  hAbnormalRisk: "Н Риск",
  highRisk: "Высокий риск",
  riskAnalysis: "Анализ риска",
  conclusionRecommendation: "Заключение и рекомендация",
  solution: "Решение",
  movePosition: "Нажмите на точку, чтобы переместить позицию",
  confirmTheClose: "Ещё не сохранено, подтвердить закрытие?",
  closeInfo: "Ещё не сохранено, подтвердить закрытие?",
  share: "Поделиться",
  front: "Передняя",
  side: "Боковая",
  back: "Задняя",
  otherSide: "Другая Сторона",
  points: "Точки",
  angle: "Угол",
  name: "Имя",
  gender: "Пол",
  male: "Мужской",
  female: "Женский",
  age: "Возраст",
  year: "лет",
  height: "Высота",
  weight: "Вес",
  time: "Время",
  patientId: "ID пациента",
  save: "Сохранить",
  saveModify: "Сохранить Изменить",
  print: "Печать",
  cancel: "Отменить",
  zoomIn: "Приблизить",
  zoomOut: "Отдалить",
  ok: "Хорошо",
  return: "Назад",
  empty: "",
  unknown: "неизвестный",
  succeedToCopy: "Успешно скопировано",
  succeedToSave: "Успешно сохранено",
  headForwardDistance: "Расстояние головы вперёд",
  pelvisForwardTilt: "Наклон таза вперёд",
  wristHipDistanceLeft: "Расстояние запястье-бедро (Левая)",
  wristHipDistanceRight: "Расстояние запястье-бедро (Правая)",
  evaluator: "Оценщик",
  reportDate: "Дата отчета",
  introduction: "Введение",
  doctorIntroDefault: "Профессиональная область: Реабилитационная медицина, оценка и коррекция осанки | Опыт работы: более 5 лет | Специализация: Реабилитация спортивных травм, коррекция осанки, управление болью",
  recoveryLog: "Журнал восстановления",
  returnToReport: "Вернуться к отчету",
  loading: "Загрузка...",
  showToolbox: "Показать инструменты",
  hideToolbox: "Скрыть инструменты",
};

